import { render } from "./AdminRiderrateDetail.vue?vue&type=template&id=4a839556&scoped=true&ts=true&lang=true"
import script from "./AdminRiderrateDetail.vue?vue&type=script&lang=ts"
export * from "./AdminRiderrateDetail.vue?vue&type=script&lang=ts"

import "./AdminRiderrateDetail.vue?vue&type=style&index=0&id=4a839556&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a839556"]])

export default __exports__